import React from 'react';
import './PageSidebar.css';

import { Button } from '../../components';

import { renderIcon } from '../../utils';



const fieldTitles = {

  // Event Single
  date: "Date",
  time: "Time",
  location: "Location",
  organizer: "Organizer",
  number: "Contact No",
  email: "Email",
  fee: "Entry Fee",

  // Project Single
  client: "Client",
  category: "Category",
  duration: "Duration",
  area: "Service Area",
  cost: "cost",
  designer: "Lead Designer",

  // Career Single
  timing: "Time Commitment",
  hours: "Working Hours",
  experience: "Experience",
  position: "Number of Positions",
  days: "Working Days",
  salary: "Salary",
  deadline: "Application Deadline",

};

const PageSidebar = (props) => {
  // Destructure props, including the optional button prop
  const { heading, details, button } = props;

  return (
    <div className='page-sidebar'>
      <h3 className="sub-heading">{heading} </h3>
      
      <div className="container">
        {Object.entries(details).map(([key, value]) => (
          // Added key prop to the outermost element in the loop
          <div className='detail-item' key={key}>
            <div className='icon'>{renderIcon(key)}</div>  
            <div className="detail-content">
              <h3>{fieldTitles[key]}</h3>
              <p>{value}</p>
            </div>
          </div>
        ))}

      </div>

      {/* Conditionally render Button if button prop exists */}
      {button && (
        <Button link={button.link} title={button.title} />
      )}

    </div>
  );
};

export default PageSidebar;